import { USER_PREFERENCE_STORAGE_KEY } from '@src/constants/MogamboConstants';

export function storeUserPreference(key, value) {
  const localStorageStr = window.localStorage.getItem(
    USER_PREFERENCE_STORAGE_KEY
  );
  let userPreferences = {};
  if (localStorageStr) {
    let storedPrefs;
    try {
      storedPrefs = JSON.parse(localStorageStr);
    } catch (err) {
      storedPrefs = null;
    }

    if (storedPrefs) {
      userPreferences = storedPrefs;
    }
  }
  userPreferences[key] = value;
  window.localStorage.setItem(
    USER_PREFERENCE_STORAGE_KEY,
    JSON.stringify(userPreferences)
  );
}

export function getUserPreference(key, defaultValue) {
  const localStorageStr = window.localStorage.getItem(
    USER_PREFERENCE_STORAGE_KEY
  );
  if (localStorageStr) {
    let storedPrefs;
    try {
      storedPrefs = JSON.parse(localStorageStr);
    } catch (err) {
      storedPrefs = null;
    }

    if (storedPrefs && storedPrefs[key] !== undefined) {
      return storedPrefs[key];
    }
  }
  return defaultValue;
}
